export const PLACE_ORDER = "PLACE_ORDER";
export const SAVE_ORDERS = "SAVE_ORDERS";
export const SAVE_ALL_ORDERS = "SAVE_ALL_ORDERS";
export const SAVE_SELECTED_ORDERS = "SAVE_SELECTED_ORDERS";
export const CLEAR_ORDER_STATE = "CLEAR_ORDER_STATE";
export const SET_PAYMENT_DETAILS = "SET_PAYMENT_DETAILS"
export const SET_IS_SUCCESS = "SET_IS_SUCCESS"